"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/watchListController',["require", "exports", "controllers/abortingRequest", "providers/ajaxSettingsProvider"], function (require, exports, abortingRequest, ajaxSettingsProvider) {
    "use strict";
    //import weatherRoutes = require('./weatherRoutes');

    var WatchListController = function () {
        function WatchListController() {
            _classCallCheck(this, WatchListController);
        }

        _createClass(WatchListController, [{
            key: "savePolicyToWatchList",
            value: function savePolicyToWatchList(data) {
                return abortingRequest.send('/api/WatchList/SavePolicyToWatchList', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "removePolicyFromWatchList",
            value: function removePolicyFromWatchList(data) {
                return abortingRequest.send('/api/WatchList/RemovePolicyFromWatchList', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "isWatching",
            value: function isWatching(data) {
                return abortingRequest.send('/api/WatchList/IsWatchingPolicy', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "updateWatchReason",
            value: function updateWatchReason(data) {
                return abortingRequest.send('/api/WatchList/UpdateWatchReason', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getWatchedPolicies",
            value: function getWatchedPolicies() {
                return abortingRequest.send('/api/WatchList/GetWatchedPolicies', ajaxSettingsProvider.httpGet(), false, false);
            }
        }]);

        return WatchListController;
    }();

    return new WatchListController();
});
//# sourceMappingURL=watchListController.js.map;
